var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cat === 'sub')?_c('ul',{ref:"categoryCarousel",attrs:{"id":"categorySlider"}},_vm._l((_vm.sliderData),function(sub){return _c('li',{key:sub.key},[_c('router-link',{staticClass:"mobislider__crcElm_a4all",attrs:{"to":{
          name: 'Subcategory',
          params: { category: _vm.category, subcat: sub.route }
        }}},[_c('span',{class:sub.icon})]),_vm._v(" "),_c('p',{staticClass:"mobislider__catLabel text_color1"},[_c('span',[_vm._v(_vm._s(sub[("titleSub_" + _vm.lang_a4all)]))])])],1)}),0):_vm._e(),_vm._v(" "),(_vm.cat === 'hot')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":2,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"hotCarousel",staticClass:"row"},_vm._l((_vm.hotpick),function(hot){return _c('div',{key:hot.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
              name: 'DetailPage',
              params: { id: hot.content_id }
            }}},[(hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":require("../../assets/funplus/imgs/html5-badge.png")}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":hot.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(hot[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(hot[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(hot["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(hot["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":3,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(hot.rating)}})],1)])])],1)}),0)])]):_vm._e(),_vm._v(" "),(_vm.cat === 'pop')?_c('div',[(_vm.category === 'video')?_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-12 col-md-4 col-lg-4 col-sm-6 mobiColItem"},[_c('router-link',{staticClass:"browse_link mobiVideo",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[_c('div',{staticClass:"mobiVideo__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.cover_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"playBtn"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"mobiVideo__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":2,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)]):_c('div',[_c('div',{ref:"popularCarousel",staticClass:"row"},_vm._l((_vm.popular),function(pop){return _c('div',{key:pop.key,staticClass:"col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem "},[_c('router-link',{staticClass:"browse_link mobiApp",attrs:{"to":{
              name: 'DetailPage',
              params: { id: pop.content_id }
            }}},[(pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game')?_c('div',{staticClass:"mobibadge badge--html5"},[_c('img',{attrs:{"src":require("../../assets/funplus/imgs/html5-badge.png")}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobiApp__thumb"},[_c('img',{staticClass:"img_wrp",attrs:{"src":pop.thumbnail_url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mobiApp__info"},[(_vm.lang_a4all !== 'english')?_c('span',[(pop[("cont_name_" + _vm.lang_a4all)] !== '')?_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(pop[("cont_name_" + _vm.lang_a4all)]))]):_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(pop["cont_name_english"]))])]):_c('span',[_c('h3',{staticClass:"mobiTitle sm text_color1"},[_vm._v(_vm._s(pop["cont_name_english"]))])]),_vm._v(" "),_c('div',[_c('star-rating',{attrs:{"inline":true,"star-size":16,"read-only":true,"increment":0.01,"active-color":"#ffe000","show-rating":false,"border-width":3,"border-color":"#ffe000","rounded-corners":false,"inactive-color":"#00923d","star-points":[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17
                  ],"rating":Number(pop.rating)}})],1)])])],1)}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ff3b4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps4all/Apps4allSlider.vue
// module id = 2357
// module chunks = 0